import { render, staticRenderFns } from "./PartCkuPrvs.vue?vue&type=template&id=303b4b76&"
import script from "./PartCkuPrvs.vue?vue&type=script&lang=js&"
export * from "./PartCkuPrvs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports